module.exports = __webpack_public_path__ + "static/img/zhubo4.291c9f4a.jpg";